import { render, staticRenderFns } from "./StarredProjectsLoaderState.vue?vue&type=template&id=2c45f342&"
import script from "./StarredProjectsLoaderState.vue?vue&type=script&lang=js&"
export * from "./StarredProjectsLoaderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.3_r_gaeimbjcwu57yzcey4waijeptq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports